import axios from "axios";
import { config } from "../../../enviroment";


export const migrateService={
    migrate,
    upload,
    retrySmsorEmail,
    newUserSms
}
async function migrate(data) {
    return await axios.post(config.urls.MIGRATE_USER,data);
  }

  async function upload(data,authToken,email) {
    let formData = new FormData();
    formData.append("uploadFile",data)
    formData.append("authToken",authToken)
    formData.append("email",email)
    return await axios.post(config.urls.UPLOAD_USER, formData,{
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    });
  }

  async function retrySmsorEmail(data) {
    return await axios.post(config.urls.REETRY_SMS_EMAIL, data);
  }

  async function newUserSms(data) {
    return await axios.post(config.urls.NEW_USER_SMS, data);
  }